import axios from './../../config/axios';

export function fetchDpk() {
    return axios().get("/sales/dpk");
}